import api from './api';

export const getReport = id => api.get(`/costs/report/${id}`);

export default getReport;
